import {HTTP} from "@/helpers/http-common"
import * as R from "ramda";

const get = (plantillaCorreo) =>new Promise((resolve,reject)=>{
  const {clave} = plantillaCorreo;
  HTTP.get(
    `/api/plantillaCorreo/${clave}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});



const save = (plantillaCorreo) =>new Promise((resolve,reject)=>{
  const {clave
    , descripcion
    , remitente
    , multiListPerfilesDestinatarios
    , destinatariosOpcionales
    , cc
    , cco
    , asunto
    , cuerpo
    , imagenes
    , status, version} = plantillaCorreo;
  HTTP
  .post(
    '/api/plantillaCorreo'
    , {clave
      , descripcion
      , remitente
      , multiListPerfilesDestinatarios
      , destinatariosOpcionales
      , cc
      , cco
      , asunto
      , cuerpo
      , imagenes
      , status, version}
  ).then(response=>{
    console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const update = (plantillaCorreo) =>new Promise((resolve,reject)=>{
  const {clave
    , descripcion
    , remitente
    , multiListPerfilesDestinatarios
    , destinatariosOpcionales
    , cc
    , cco
    , asunto
    , cuerpo
    , imagenes
    , status, version} = plantillaCorreo;
  HTTP
  .put(
    '/api/plantillaCorreo'
    , {clave
      , descripcion
      , remitente
      , multiListPerfilesDestinatarios
      , destinatariosOpcionales
      , cc
      , cco
      , asunto
      , cuerpo
      , imagenes
      , status, version}
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const disable = (plantillaCorreo) =>new Promise((resolve,reject)=>{
  const {clave} = plantillaCorreo;
  HTTP
  .delete(
    "/api/plantillaCorreo/"
    , {
      params:{clave}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

//Export methods
export default {
  get
  , save
  , update
  , disable
}





// WEBPACK FOOTER //
// ./src/services/generales/plantillaCorreo/index.js